import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import { useAuth } from '@/features/auth/providers/AuthProvider';
import { SuggestionsInbox } from '@/features/suggestions/components/SuggestionsInbox';

export const Route = createFileRoute('/admin/suggestions')({
  component: RouteComponent,
});

function RouteComponent() {
  const { user, loading: authLoading, roleReady } = useAuth();
  const location = useLocation();

  if (authLoading || !roleReady) return null;

  if (!user) {
    return <Navigate to="/login" search={{ from: location.pathname }} replace />;
  }

  if (user.role !== 'admin' && user.role !== 'officeManager') {
    return <Navigate to="/" replace />;
  }

  return <SuggestionsInbox />;
}
